export default __webpack_public_path__ + "1cf3cfd636a6c1ca84dd089fc50c01f0.jpg";